import React from 'react';

import { compose, withProps, lifecycle } from 'recompose';
import { withScriptjs } from 'react-google-maps';
import { StandaloneSearchBox } from 'react-google-maps/lib/components/places/StandaloneSearchBox';

const GOOGLE_MAP_API_KEY = 'AIzaSyC7qrobHawZxvm8nKCm0M_exrXAKnM_bR4';

export const PlacesWithStandaloneSearchBox = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: '100%' }} />,
    containerElement: <div style={{ height: '400px' }} />
  }),
  lifecycle({
    componentWillMount() {
      const refs = {};

      this.setState({
        fullLocation: (this.props && this.props.defaultValue) ? this.props.defaultValue : '',
        city: '',
        state: '',
        postalCode: '',

        onSearchBoxMounted: ref => {
          refs.searchBox = ref;
        },

        onPlacesChanged: () => {
          const places = this.autocomplete.getPlace(); //refs.searchBox.getPlaces()[0];

          if (places) {
            let item = { street_number: '', route: '', locality: '', administrative_area_level_1: '', country: '', postal_code: '' };

            const componentForm = {
              street_number: 'short_name',
              route: 'long_name',
              locality: 'long_name',
              administrative_area_level_1: 'short_name',
              country: 'long_name',
              postal_code: 'short_name'
            };

            for (var i = 0; i < places.address_components.length; i++) {
              var addressType = places.address_components[i].types[0];
              if (componentForm[addressType]) {
                item[addressType] = places.address_components[i][componentForm[addressType]];
              }
            }
            const input = document.getElementById('search-input-control');

            this.setState({
              fullLocation: input.value,
              city: item.locality,
              state: item.administrative_area_level_1,
              postalCode: item.postal_code
            }, () => {
              this.props.onChange(this.state);
            });
          }
        },

        handleChange: (e) => {
          this.setState({
            fullLocation: e.target.value,
            city: '',
            postalCode: '',
            state: ''
          }, () => {
            this.props.onChange(this.state);
          });
        }
      }, () => {
        const interval = window.setInterval(() => {
          if (refs.searchBox) {

            // overwrite autocomplete
            const input = document.getElementById('search-input-control');
            this.autocomplete = new google.maps.places.Autocomplete(input);
            this.autocomplete.setComponentRestrictions({ country: ['us', 'ca'] });
            this.autocomplete.addListener('place_changed', this.state.onPlacesChanged);

            // remove default autocomplete
            const divPacControl = document.getElementsByClassName('pac-container');
            if (divPacControl && divPacControl[0] && divPacControl[0].parentNode && divPacControl[0].parentNode.removeChild) {
              divPacControl[0].parentNode.removeChild(divPacControl[0]);
            }

            // clear interval when finish overwrite autocomplete
            window.clearInterval(interval);
          }
        }, 500);
      });
    },

    componentWillReceiveProps(nextProps) {
      if (!this.props.isCreate && nextProps.fullLocation) {
        this.setState({
          fullLocation: nextProps.fullLocation,
          city: nextProps.city,
          state: nextProps.state,
          postalCode: nextProps.postalCode
        }, () => {
          this.props.onChange(this.state);
        });
      }
    }
  }),
  withScriptjs
)(props =>
  <div data-standalone-searchbox=''>
    <StandaloneSearchBox
      ref={props.onSearchBoxMounted}
      bounds={props.bounds}
      onPlacesChanged={props.onPlacesChanged}
    >
      <div className='form-group'>
        <input
          className='form-control'
          type='text'
          value={props.fullLocation}
          onChange={props.handleChange}
          disabled={props.disabled}
          id='search-input-control'
          placeholder='Type in an address' />
      </div>
    </StandaloneSearchBox>
  </div>

);



// WEBPACK FOOTER //
// ./src/components/geo-complete/CustomMap.js